module.exports = __webpack_public_path__ + "static/media/licenta14.4874eb48.png";